export const quoteModern = {
  colors: {
    orange: "#FB8E00",
    orangeHover: "#E67F00",
    orangeSoft: "#FFF3E3",

    pageBg: "#F3F4F6",
    sheetBg: "#F8F9FA",
    cardBg: "#FFFFFF",

    textPrimary: "#0F172A",
    textSecondary: "#64748B",
    textMuted: "#94A3B8",
    textSoft: "#CBD5E1",

    line: "#EEF2F7",
    shadow: "0px 4px 20px rgba(15, 23, 42, 0.04)",
  },

  cardSx: {
    p: 2,
    borderRadius: 2.5,
    bgcolor: "var(--fx-surface-base, #FFFFFF)",
    boxShadow: "0px 4px 20px rgba(15, 23, 42, 0.04)",
    border: "1px solid var(--fx-surface-border, #E2E8F0)",
  },

  labelSx: {
    fontSize: 11,
    fontWeight: 800,
    color: "var(--fx-surface-texttertiary, #94A3B8)",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    lineHeight: 1,
  },

  iconBoxSx: {
    width: 32,
    height: 32,
    borderRadius: 2,
    bgcolor: "var(--fx-colors-warning-50, #FFF7ED)",
    color: "#FB8E00",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 800,
    fontSize: 15,
  },
} as const;
